import API from '@/services/QFDAPIService';

export default {
	name: 'TenantService',
	getTenantList() {
		return API.call('/tenant/list',{}, "Auth");
	},
	
	/**
     * Retrieve the tenant configuration
     * @param {Object} params
     * @returns an object containing configuration tenant values
     */
    retrieveTenantConfiguration({ TenantId }, dispatch) {
        return API.call('/tenant/retrieve', { TenantId }).catch(error => {
            if (error.message) {
                dispatch("notifications/addNotification", {
                    status: 'error',
                    message: 'A ' + error.message + ' has occurred. Please refresh the page or try again later.',
                });
            } else {
                dispatch("notifications/addNotification", {
                    status: 'error',
                    message: 'An error has occurred. Please refresh the page or try again later.',
                });
            }
        })
    },
};